import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const SEMESTER_OPTIONS = [1, 2];

export default function TermFormDialog({ open, onClose, term, onSave }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    year: "",
    semester: "",
    start_date: "",
    end_date: "",
    name: "",
  });

  useEffect(() => {
    if (term) {
      setForm({
        year: term.year ?? "",
        semester: term.semester != null ? String(term.semester) : "",
        start_date: term.start_date ? term.start_date.slice(0, 10) : "",
        end_date: term.end_date ? term.end_date.slice(0, 10) : "",
        name: term.name || "",
      });
    } else {
      setForm({ year: "", semester: "", start_date: "", end_date: "", name: "" });
    }
  }, [term, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      year: form.year ? Number(form.year) : null,
      start_date: form.start_date || null,
      end_date: form.end_date || null,
      name: form.name || "",
    };
    if (term) payload.semester = form.semester ? Number(form.semester) : null;
    else payload.semester = null;
    onSave(payload);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{term ? t("academic.editTerm", "Edit Term") : t("academic.addTerm", "Add Term")}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required name="year" type="number" inputProps={{ min: 1, max: 7 }} label={t("academic.year", "Year")} value={form.year} onChange={handleChange} size="small" />
            </Grid>
            {term && (
              <Grid item xs={12} sm={6}>
                <TextField fullWidth name="semester" select label={t("academic.semester", "Semester")} value={form.semester} onChange={handleChange} size="small">
                  <MenuItem value="">{t("academic.stageOrNone", "Stage / None")}</MenuItem>
                  {SEMESTER_OPTIONS.map((s) => (
                    <MenuItem key={s} value={String(s)}>{t("academic.semesterNum", { count: s }) || `Sem ${s}`}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required name="start_date" type="date" label={t("academic.startDate", "Start date")} value={form.start_date} onChange={handleChange} InputLabelProps={{ shrink: true }} size="small" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required name="end_date" type="date" label={t("academic.endDate", "End date")} value={form.end_date} onChange={handleChange} InputLabelProps={{ shrink: true }} size="small" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth name="name" label={t("academic.termName", "Name (optional)")} value={form.name} onChange={handleChange} size="small" placeholder="e.g. 2024-2025 Year 1 Sem 1" />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t("common.cancel", "Cancel")}</Button>
          <Button type="submit" variant="contained" disabled={!form.year || !form.start_date || !form.end_date}>{t("common.save", "Save")}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
